import _defineProperty from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import _objectWithoutProperties from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["className"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { forwardRef } from "react";
import classnames from "classnames";
import styles from "@/styles/Form.module.scss";
import { usePreventContextMenu } from "@/hooks";
import { jsx as _jsx } from "react/jsx-runtime";
var SearchInputField = /*#__PURE__*/forwardRef(function (props, ref) {
  var className = props.className,
      _props = _objectWithoutProperties(props, _excluded);

  var _usePreventContextMen = usePreventContextMenu(),
      _usePreventContextMen2 = _slicedToArray(_usePreventContextMen, 2),
      on = _usePreventContextMen2[0],
      off = _usePreventContextMen2[1];

  return /*#__PURE__*/_jsx("div", {
    className: styles.searchInputField,
    children: /*#__PURE__*/_jsx("input", _objectSpread({
      ref: ref,
      className: classnames(styles.searchInput, className),
      defaultValue: "",
      type: "search",
      autoComplete: "off",
      onFocus: off,
      onBlur: on
    }, _props))
  });
});
SearchInputField.displayName = "SearchInputField";
export default SearchInputField;